<gyd-greetings-widget *ngIf="displayGreetingHeader | async">
</gyd-greetings-widget>
